function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.3785 5.8964C17.5434 5.25255 16.5081 4.97177 15.4633 5.10573C14.4185 5.23971 13.4893 5.77242 12.8468 6.60568L8.51737 12.2214C7.72164 13.2535 7.91579 14.7419 8.95022 15.5395C9.98464 16.3369 11.4735 16.1459 12.2693 15.1138L14.7675 11.8734C15.0332 11.5288 14.9686 11.0336 14.6233 10.7673C14.2779 10.5011 13.7826 10.5646 13.5169 10.9092L11.0187 14.1496C10.7534 14.4937 10.257 14.5573 9.9123 14.2916C9.5675 14.0258 9.50274 13.5296 9.76799 13.1855L14.0975 7.56986C14.4829 7.06987 15.0405 6.75026 15.6674 6.66988C16.2943 6.5895 16.9154 6.75797 17.4164 7.14425C18.4509 7.94175 18.6451 9.4302 17.8494 10.4623L13.039 16.7019C11.7127 18.422 9.23113 18.7403 7.5072 17.4112C6.67209 16.7674 6.13705 15.8376 6.00084 14.7931C5.86457 13.7486 6.14339 12.7144 6.78586 11.881L11.5962 5.64148C11.8619 5.29685 11.7973 4.80169 11.4519 4.53545C11.1066 4.26921 10.6112 4.33272 10.3456 4.67731L5.53525 10.9169C4.63576 12.0835 4.24547 13.5313 4.43618 14.9937C4.62692 16.456 5.37587 17.7578 6.5451 18.6591C8.95857 20.5198 12.4327 20.0744 14.2895 17.6661L19.1 11.4265C20.4261 9.70633 20.1025 7.22551 18.3785 5.8964Z",
  fill: "#8181A5"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(4 4)"
})));

function SvgAttachement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachement);
export default __webpack_public_path__ + "static/media/attachement.32b453e9.svg";
export { ForwardRef as ReactComponent };